export const TRACKING_EVENTS = {
    "LANDED_ON_POST_BC": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "landed_post_bc_tasks_page",
        "eventLabel": "<order_id>"
    },
    "CTA_CLICKED": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "{Name of click}_cta_clicked",
        "eventLabel": "<order_id>"
    },
    "ICON_HYPERLINK_CLICKED": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "{Name of hyperlink_click}_icon_hyperlink_clicked",
        "eventLabel": "<order_id>"
    },
    "APP_DOWNLOAD_CTA_CLICKED": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "app_download_cta_clicked_{Location}",
        "eventLabel": "<order_id>"
    },
    "APP_DOWNLOAD_LOAN_PAGE_CLICKED": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "app_download_cta_clicked_loan_page",
        "eventLabel": "<order_id> & <loan_status>"
    },
    "VAS_CHANGE": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "{VAS}_{added or removed}_{location}",
        "eventLabel": "<order_id>"
    },
    "WARRANTY_CHANGE_LOAN_PAGE": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "warranty_{added or removed}_loan_page",
        "eventLabel": "<order_id> & <loan_status>"
    },
    "DELIVERY_SCHEDULE_LANDED": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "Delivery_schedule_page_landed_{Landed type}",
        "eventLabel": "<order_id>"
    },
    "DELIVERY_ADDRESS_UPDATED": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "home_delivery_address_updated",
        "eventLabel": "<order_id>"
    },
    "DELIVERY_ACTION": {
        "event": "custom_event",
        "eventCategory": "post_bc",
        "eventAction": "delivery_{Action}",
        "eventLabel": "<order_id>"
    }
};
